/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Today_EarnedInputs */

const en_features_today_earned = /** @type {(inputs: Features_Today_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

const pl_features_today_earned = /** @type {(inputs: Features_Today_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziś`)
};

/**
* | output |
* | --- |
* | "Today" |
*
* @param {Features_Today_EarnedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_today_earned = /** @type {((inputs?: Features_Today_EarnedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Today_EarnedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_today_earned(inputs)
	return en_features_today_earned(inputs)
});